export interface PeuPayments {
    fee: string;
    id: string;
    items: [
        {
            documentType: string;
            administrativeFee: number;
            taxFee: number;
            postalFee: number;
            signatureFee: number;
            quantity: number;
            version: string;
        }
    ];
}

export interface PayWithRedirectResponse {
    billId: string;
    paidAmount: number;
    paymentId: string;
    paymentStatus: PeuPaymentStatus;
    redirectUrl: string;
  }

  export interface PayWithBlikResponse {
    billId: string;
    fee: number;
    paidAmount: number;
    paymentId: string;
    paymentStatus: PeuPaymentStatus;
    registerFeeSum: number;
    taxFeeSum: number;
    postalFeeSum: number;
    administrativeFeeSum: number;
    urlFailure: string;
    urlSuccess: string;
  }

export enum PeuPaymentStatus {
    AUTHPENDING = 'AUTHPENDING',
    AUTHACCEPTED = 'AUTHACCEPTED',
    AUTHREJECTED = 'AUTHREJECTED',
    EXCEEDED = 'EXCEEDED'
}